export default __webpack_public_path__ + "static/media/sidebar-bg.1b99f4eb.jpg";